import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import CheckBox from "."

export default function CheckBoxFieldWrapper({ name, ...rest }) {
  const { field, error, helpers } = useFastField(name)
  const { setTouched, setValue } = helpers
  const onChange = useCallback(e => setValue(e.target.checked), [setValue])
  const onBlur = useCallback(() => setTouched(true), [setTouched])

  return <CheckBox {...field} error={error} onBlur={onBlur} onChange={onChange} {...rest} />
}

CheckBoxFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
